import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { KkmModalComponent } from '../kkms/kkm-modal.component';
import { ICtoContract } from '../../../core/models/cto.model';
import { ModalService } from '../../../core/modal/modal.service';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';

@Component({
  selector: 'tax-edit-cto',
  templateUrl: './edit-cto.component.html',
  styleUrls: ['./edit-cto.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class EditCtoComponent implements OnInit, OnDestroy {
  // @ts-ignore
  ctoContract: ICtoContract;
  // @ts-ignore
  kkmIds: Array<number>;
  isModelVisible: boolean = false;
  userAgreement: boolean = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private ctoApiService: CtoApiService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    // @ts-ignore
    const contractId: string = this.route.snapshot.paramMap.get('id');
    this.ctoApiService.fetchContract(contractId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: ICtoContract) => {
          this.ctoContract = response;
          this.kkmIds = response.kkms.map(i => i.id);
          this.changeDetectorRef.markForCheck();
        },
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  // @ts-ignore
  getServicedModels(servicedModels: Map<string, string>): Array<string> {
    if (servicedModels) {
      return Object.values(servicedModels);
    }
  }

  goBack(): void {
    this.location.back();
  }

  convertKkmIdsToString(kkms?: Array<number>): string {
    if (kkms && kkms.length) {
      return (`ID: ${kkms.join(', ')}`);
    }
    return '';
  }

  createComponent(): void {
    this.modalService.openOld(KkmModalComponent, {
      initialState: this.kkmIds,
    }, {
      width: '740px',
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedItems: number[]) => {
        if (!selectedItems) {
          return;
        }
        this.kkmIds = selectedItems;
        this.changeDetectorRef.detectChanges();
      });
  }

  canSaveCto(): boolean {
    return (
      this.kkmIds
      && this.kkmIds.length > 0
      && this.userAgreement);
  }

  saveCto(): void {
    this.ctoApiService.addKkms({
      kkmIds: this.kkmIds, contractId: this.ctoContract.id,
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => this.router.navigate(['/main/cto', this.ctoContract.id]),
      );
  }
}
